function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { TOOLTIP_Y_OFFSET as e, TRIANGLE_OFFSETS as t, DEFAULT_OFFSET as m, UP_ARROW as O, TOOLTIP_X_OFFSET as w, LEFT_ARROW as p, RIGHT_ARROW as R, TRIANGLE_BORDER as T } from "./index.es15.js";
import { PositionVariants as r } from "./index.es172.js";
var F = function F(c, h) {
  var f = c.width,
    g = c.height,
    o = c.left,
    d = c.right,
    n = c.top,
    a = c.bottom,
    _document$documentEle = document.documentElement,
    l = _document$documentEle.clientHeight,
    i = _document$documentEle.clientWidth,
    s = f / 2 - t.x - T;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, r.aboveRight, {
    bottom: l - n + e,
    left: o + s + window.scrollX,
    triangleOffset: {
      bottom: t.y,
      left: t.x,
      transform: m.triangleOffset.transform
    }
  }), r.aboveCenter, {
    bottom: l - n + e,
    left: o + f / 2 + window.scrollX,
    transform: "translate(-50%, 0)",
    triangleOffset: {
      bottom: t.y,
      transform: m.triangleOffset.transform
    }
  }), r.aboveLeft, {
    bottom: l - n + e,
    right: i - d + s - window.scrollX,
    triangleOffset: {
      bottom: t.y,
      right: t.x,
      transform: m.triangleOffset.transform
    }
  }), r.underRight, {
    top: a + e,
    left: o + s + window.scrollX,
    triangleOffset: {
      top: t.y,
      left: t.x,
      transform: "rotate(".concat(O, ")")
    }
  }), r.underCenter, {
    top: a + e,
    left: o + f / 2 + window.scrollX,
    transform: "translate(-50%)",
    triangleOffset: {
      top: t.y,
      transform: "rotate(".concat(O, ")")
    }
  }), r.underLeft, {
    top: a + e,
    right: i - d + s - window.scrollX,
    triangleOffset: {
      top: t.y,
      right: t.x,
      transform: "rotate(".concat(O, ")")
    }
  }), r.left, {
    top: n + g / 2,
    right: i - o + w - window.scrollX,
    transform: "translate(0, -50%)",
    triangleOffset: {
      right: t.y,
      transform: "rotate(".concat(p, ")")
    }
  }), r.right, {
    top: n + g / 2,
    left: o + f + w + window.scrollX,
    transform: "translate(0, -50%)",
    triangleOffset: {
      left: t.y,
      transform: "rotate(".concat(R, ")")
    }
  })[h];
};
export { F as defineOffset };